import { AccApplicationStatusId } from "../db-enums/acc-application-status-id";
import { CommitmentMatchDifficulty } from "./commitment";
import { StandardFourTimeZoneId } from "./schedule";

export enum AccProspectTypeEnum {
	Application = 'Application',
	DeferredApplication = 'Deferred Application',
	OpenLead = 'Open Lead'
}

export type AccProspectType = `${AccProspectTypeEnum}`;
export interface AccProspect {
	accProspectId: number,
	type: AccProspectType,
	accLeadId: number | undefined,
	accApplicationId: number | undefined,
	personId: number,
	fullName: string,
	combinedAlignmentsScore: number | undefined,
	admissionsScore: number | undefined,
	isPriority: boolean,
	score: number,
	rank: number | undefined,
	orderOfApplications: number | undefined,
	orderOfLeads: number | undefined,
	orderOfDeferrals: number | undefined,
	languageId: number,
	readinessCompletion: number | undefined,
	ventureName: string | undefined,
	accAppStatusId: AccApplicationStatusId | undefined, // only for acc application records
	trimesterSwitchoverOldStatusId: AccApplicationStatusId | undefined, // only for deferred acc application records
	isDeferred: boolean | undefined,	// only for acc application records
	wasDeferredApplicant: boolean | undefined,	// only for acc application records
	hasVeryHighIncome: boolean,
	businessStage: '0' | '1' | '2',
	businessType: 'For Profit' | 'Non-Profit',
	offerings: 'Products' | 'Services' | 'Both',
	industryId: number,
	questionnaireLearnId: number | undefined, // only for lead records
	location: string | undefined, // current city, state and zip code or legacy address
	leadStartTrimesterId: number | undefined, // only for lead records
	lastContactUTC?: number,
	lastContactStaffId?: number,
	lastAutoEmailDeliveredUTC?: number,
	assignedToStaffId: number | undefined,
	updatedUTC: number // updatedUTC of accLead / accApplication
}

export interface AccProspectAlignedAccelerator {
	accProspectAcceleratorId: number,
	accId: number,
	gravityMiles: number,
	trimesterId: number,
	meetingStartSlot: number,
	availableSeatCount: number,
	seatsOffered: number,
	seatsAccepted: number,
	languageId: number,
	accTimeZoneId: StandardFourTimeZoneId,
}

export interface AccProspectAlignedCommitment {
	accProspectCommitmentId: number,
	commitmentId: number,
	name: string,
	donorId: number,
	donorName: string,
	impact: 'Critical' | 'Important' | 'Standard' | 'Internal',
	startTrimesterId: number,
	endTrimesterId: number,
	matchRatio: number | undefined,
	graduatedVenturesPromised: number,
	actualProgress: number,
	potentialProgress: number,
	urgency: number,
	matchDifficulty: CommitmentMatchDifficulty,
}